module.exports = __webpack_public_path__ + "static/media/VectorStage.0d92f79c.svg";